import React, { useEffect } from "react";

import Limpieza from "../../navigation/v2/finances/promotions/limpieza";
import "../../navigation/v2/finances/promotions/promotions.css";

/*
	La Limpieza de UNA persona, en ventana (Esteban, 2026-11-02): desde el Estado de Cuenta o Registrar Pago, Caja revisa y decide la
	promoción de su matrícula ahí mismo, antes de cobrar. Mientras siga «Por revisar», el servidor no deja cobrar sus mensualidades ni
	ponerle descuento por otro lado (LimpiezaAcuerdosService::exigirLimpiezaHecha). campusId = el plantel del caso.
*/
const LimpiezaDelAlumno: React.FC<{ campusId: number; studentId: number; enrollmentId?: number; nombre: string; onClose: (cambio: boolean) => void }> =
	({ campusId, studentId, enrollmentId, nombre, onClose }) => {
	const cambio = React.useRef(false);
	const cerrar = React.useCallback(() => onClose(cambio.current), [onClose]);
	// Marca el body: «Ver Perfil» (react-modal) se abre encima de esta ventana (app.css, waVentanaDescuentos).
	useEffect(() => {
		document.body.classList.add("waVentanaDescuentos");
		return () => document.body.classList.remove("waVentanaDescuentos");
	}, []);
	useEffect(() => {
		const esc = (e: KeyboardEvent) => { if (e.key === "Escape") cerrar(); };
		window.addEventListener("keydown", esc);
		return () => window.removeEventListener("keydown", esc);
	}, [cerrar]);
	return (
		<div className="wdVentanaFondo" onClick={cerrar}>
			<div className="wdVentana waDescuentos" role="dialog" aria-label={"Revisar promoción de " + nombre} onClick={(e) => e.stopPropagation()}>
				<div className="wdVentanaCab">
					<div style={{ minWidth: 0 }}>
						<div className="wdVentanaTit">Revisar Promoción · {nombre}</div>
						<div className="wdTenue" style={{ fontSize: 13 }}>Antes de cobrar: confirma la promoción que ya tenía (o «Sin Promoción»). Lo ya pagado no cambia.</div>
					</div>
					<button type="button" className="wdBoton" onClick={cerrar}>Cerrar</button>
				</div>
				<div className="wdVentanaCuerpo">
					<Limpieza campusId={campusId} sym="" soloAlumno={{ studentId, enrollmentId }} onDecidido={() => { cambio.current = true; }} />
				</div>
			</div>
		</div>
	);
};

export default LimpiezaDelAlumno;
